import { Programme } from "./programme.model";

export class Competence {
  competenceId: number;
  code: string;
  numero: number;
  enonce: string;
  programmeId: number;
  programme: Programme;
}
